module.exports = __webpack_public_path__ + "static/media/16.636bd74a.jpg";